var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-card",
        { staticClass: "mt-3" },
        [
          _c(
            "b-card-title",
            { staticClass: "text-primary ml-2 mr-2 d-inline" },
            [_c("h3", [_vm._v("Relatório de falhas")])]
          ),
          _vm._v(" "),
          _c(
            "b-card-body",
            [
              _c(
                "b-row",
                { staticClass: "mt-2", attrs: { "align-v": "end" } },
                [
                  _c(
                    "b-col",
                    { staticClass: "col-md-2" },
                    [
                      _c("label", { attrs: { for: "statu" } }, [
                        _vm._v("Status")
                      ]),
                      _vm._v(" "),
                      _c("b-form-select", {
                        attrs: {
                          size: "sm",
                          id: "statu",
                          options: _vm.options
                        },
                        model: {
                          value: _vm.status,
                          callback: function($$v) {
                            _vm.status = $$v
                          },
                          expression: "status"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { staticClass: "col-md-2" },
                    [
                      _c("label", { attrs: { for: "rev" } }, [
                        _vm._v("Revendedora")
                      ]),
                      _vm._v(" "),
                      _c("b-form-input", {
                        attrs: {
                          size: "sm",
                          autofocus: "",
                          id: "rev",
                          placeholder: "Maria da Silva"
                        },
                        model: {
                          value: _vm.revend,
                          callback: function($$v) {
                            _vm.revend = $$v
                          },
                          expression: "revend"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { staticClass: "col-md-2" },
                    [
                      _c("label", { attrs: { for: "in" } }, [_vm._v("Início")]),
                      _vm._v(" "),
                      _c("b-form-datepicker", {
                        attrs: {
                          id: "in",
                          placeholder: "Nenhuma Data",
                          "calendar-width": "200",
                          "label-no-date-selected": "",
                          "label-next-month": "Próximo Mês",
                          "label-next-year": "Próximo Ano",
                          "label-prev-month": "Mês Anterior",
                          "label-prev-year": "Ano Anterior",
                          "label-current-month": "Mês Atual",
                          "label-help": "",
                          "hide-header": "",
                          size: "sm",
                          "date-format-options": {
                            year: "numeric",
                            month: "numeric",
                            day: "numeric"
                          },
                          locale: "pt-BR"
                        },
                        model: {
                          value: _vm.inicio,
                          callback: function($$v) {
                            _vm.inicio = $$v
                          },
                          expression: "inicio"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { staticClass: "col-md-2" },
                    [
                      _c("label", { attrs: { for: "fi" } }, [_vm._v("Fim")]),
                      _vm._v(" "),
                      _c("b-form-datepicker", {
                        attrs: {
                          id: "fi",
                          placeholder: "Nenhuma Data",
                          "calendar-width": "200",
                          "label-no-date-selected": "",
                          "label-next-month": "Próximo Mês",
                          "label-next-year": "Próximo Ano",
                          "label-prev-month": "Mês Anterior",
                          "label-prev-year": "Ano Anterior",
                          "label-current-month": "Mês Atual",
                          "label-help": "",
                          hover: "",
                          "hide-header": "",
                          size: "sm",
                          "date-format-options": {
                            year: "numeric",
                            month: "numeric",
                            day: "numeric"
                          },
                          locale: "pt-BR"
                        },
                        model: {
                          value: _vm.fim,
                          callback: function($$v) {
                            _vm.fim = $$v
                          },
                          expression: "fim"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    [
                      _c(
                        "b-button",
                        {
                          attrs: { size: "sm", variant: "primary" },
                          on: {
                            click: function($event) {
                              return _vm.buscar()
                            }
                          }
                        },
                        [
                          _vm.loading
                            ? _c("b-spinner", {
                                attrs: { small: "", label: "Loading..." }
                              })
                            : _vm._e(),
                          _vm._v("\n            Buscar\n          ")
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { staticClass: "text-right" },
                    [
                      _c(
                        "b-button",
                        {
                          attrs: { variant: "success", size: "sm" },
                          on: { click: _vm.exportar }
                        },
                        [
                          _c("i", { staticClass: "far fa-file-excel" }),
                          _vm._v(" Exportar")
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                { staticClass: "mt-3" },
                [
                  _c("b-table", {
                    attrs: {
                      items: _vm.revendedoras,
                      fields: _vm.fields,
                      "current-page": _vm.currentPage,
                      "per-page": _vm.perPage,
                      "sort-by": _vm.sortBy,
                      stacked: "md",
                      "show-empty": "",
                      "empty-text": "Nenhuma Revendedora Encontrada!",
                      responsive: "",
                      striped: "",
                      small: ""
                    },
                    on: {
                      "update:sortBy": function($event) {
                        _vm.sortBy = $event
                      },
                      "update:sort-by": function($event) {
                        _vm.sortBy = $event
                      }
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "table-busy",
                        fn: function() {
                          return [
                            _c(
                              "div",
                              { staticClass: "text-center text-danger my-2" },
                              [
                                _c("b-spinner", {
                                  staticClass: "align-middle"
                                }),
                                _vm._v(" "),
                                _c("strong", [
                                  _vm._v("Listando Revendedoras ...")
                                ])
                              ],
                              1
                            )
                          ]
                        },
                        proxy: true
                      },
                      {
                        key: "cell(ativa)",
                        fn: function(row) {
                          return [
                            row.item.ativa == true
                              ? _c(
                                  "b-badge",
                                  { attrs: { variant: "success" } },
                                  [_vm._v("Ativa")]
                                )
                              : _c(
                                  "b-badge",
                                  { attrs: { variant: "danger" } },
                                  [_vm._v("Inativa")]
                                )
                          ]
                        }
                      }
                    ])
                  })
                ],
                1
              ),
              _vm._v(" "),
              _vm.revendedoras.length > 0
                ? _c(
                    "b-row",
                    { attrs: { "align-h": "end" } },
                    [
                      _c(
                        "b-col",
                        { staticClass: "md-8" },
                        [
                          _c("b-pagination", {
                            staticClass: "my-0",
                            attrs: {
                              "total-rows": _vm.totalRows,
                              "per-page": _vm.perPage,
                              align: "fill",
                              size: "sm"
                            },
                            model: {
                              value: _vm.currentPage,
                              callback: function($$v) {
                                _vm.currentPage = $$v
                              },
                              expression: "currentPage"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("b-col", { staticClass: "text-right" }, [
                        _vm._v(
                          "\n          Total de Registros: " +
                            _vm._s(_vm.revendedoras.length) +
                            "\n        "
                        )
                      ])
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-253da0b4", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-253da0b4","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/distribuidor/relatorio/Falha.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-253da0b4","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/distribuidor/relatorio/Falha.vue
// module chunks = 2